import FocusLock, { AutoFocusInside } from "react-focus-lock";

import { WebPlatformProvider } from "@smartrent/shared-ui";

import { PositionAwarePortal } from "../components/PositionAwarePortal";
import { Modal } from "../components/Modal";
import { useNavigation } from "../hooks/useNavigation";

import type { ReactNode } from "react";

export function PlatformProvider({ children }: { children: ReactNode }) {
  return (
    <WebPlatformProvider
      components={{
        PositionAwarePortal,
        Modal,
        FocusLock,
        AutoFocusInside,
      }}
      modules={{
        DocumentPicker: undefined,
        ImagePicker: undefined,
      }}
      hooks={{
        useNavigation,
      }}
    >
      {children}
    </WebPlatformProvider>
  );
}
